import React from "react";
import PropTypes from "prop-types";
import { Room as RoomIcon } from "@mui/icons-material";

function PublicJobsList(props) {
  const {
    jobs,
    selectedJob,
    setSelectedJob,
  } = props;

  const items = jobs.map((job, index) => (
    <button
        className={"JobButton w-full capitalize p-2 rounded-md border-2 drop-shadow-2xl mb-2" + (job.jobId === selectedJob.jobId ? " border-brand-primary" : " border-gray")}
        key={index}
        type="button"
        onClick={() => setSelectedJob(job)}
    >
      <div className="JobButton-level text-base font-brand-primary flex mb-2">
        {Array.isArray(job.jobLevel) ?
          job.jobLevel.join(", ") :
          job.jobLevel}
      </div>

      <div className="JobButton-title text-xl font-bold font-brand-primary text-start flex mb-2">
        {job.title}
      </div>
      <div className="JobButton-level text-base font-brand-primary flex mb-2">
        {Array.isArray(job.jobType) ? job.jobType.join(", ") : job.jobType}
      </div>
      <div className="JobButton-location text-base mb-3 flex justify-start py-auto">
        <RoomIcon fontSize="medium" className="flex my-auto mr-1" />
        <div className="text-start">{job.location}</div>
      </div>
      <div className="JobButton-company text-base font-brand-primary flex">
        {job.company}
      </div>
    </button>
  ));

  if (jobs.length === 0) {
    return (
      <div className="PublicJobsList bg-white p-2 mr-4 rounded-xl h-5/6">
        No jobs found.
      </div>
    );
  } else {
    return (
      <div className="PublicJobsList h-full bg-white rounded-xl py-2 pl-2 pr-px">
            <div className="PublicJobsList-list overflow-y-auto h-full">
                {
                    jobs.length === 0 ?
                    "No jobs found." :
                    items
                }
            </div>
        </div>
    );
  }
}

PublicJobsList.propTypes = {
  jobs: PropTypes.arrayOf({
    applyDetails: PropTypes.string,
    company: PropTypes.string,
    companyLink: PropTypes.string,
    details: PropTypes.string,
    draft: PropTypes.bool,
    endDate: PropTypes.string,
    jobId: PropTypes.number,
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobType: PropTypes.arrayOf(PropTypes.string),
    location: PropTypes.string,
    skills: PropTypes.arrayOf(PropTypes.string),
    startDate: PropTypes.string,
    title: PropTypes.string
  }),
  selectedJob: PropTypes.shape({
    title: PropTypes.string,
    location: PropTypes.string,
    company: PropTypes.string,
    details: PropTypes.string,
    companyLink: PropTypes.string,
    applyDetails: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    jobType: PropTypes.arrayOf(PropTypes.string),
    jobLevel: PropTypes.arrayOf(PropTypes.string),
    jobIndustry: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
    jobId: PropTypes.number,
  }),
  setSelectedJob: PropTypes.func,
};

PublicJobsList.defaultProps = {
  jobs: [],
  selectedJob: { },
  setSelectedJob: () => { }
};

export default PublicJobsList;
